import { render, staticRenderFns } from "./PanelInputNumber.vue?vue&type=template&id=4de563f2&scoped=true&"
import script from "./PanelInputNumber.vue?vue&type=script&lang=js&"
export * from "./PanelInputNumber.vue?vue&type=script&lang=js&"
import style0 from "./PanelInputNumber.vue?vue&type=style&index=0&id=4de563f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de563f2",
  null
  
)

component.options.__file = "PanelInputNumber.vue"
export default component.exports